module.exports = __webpack_public_path__ + "static/media/laptop_mockup.fc417560.png";